import { render, staticRenderFns } from "./PagesVideoWidget.vue?vue&type=template&id=e5538068&scoped=true&"
import script from "./PagesVideoWidget.vue?vue&type=script&lang=js&"
export * from "./PagesVideoWidget.vue?vue&type=script&lang=js&"
import style0 from "./PagesVideoWidget.vue?vue&type=style&index=0&id=e5538068&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5538068",
  null
  
)

export default component.exports